import { render, staticRenderFns } from "./paySuccess.vue?vue&type=template&id=32c60772&scoped=true&"
import script from "./paySuccess.vue?vue&type=script&lang=js&"
export * from "./paySuccess.vue?vue&type=script&lang=js&"
import style0 from "./paySuccess.vue?vue&type=style&index=0&id=32c60772&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c60772",
  null
  
)

export default component.exports